import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {DeleteModal} from "components";
import {MainInfo} from "fragments";
import {AddUser} from "./fragments";
import {UserSingle} from "./userSingle";
import {emptyState, usersBody, usersHead} from "./constants";
import {httpRequestsOnSuccessActions, usersActions} from "store";
import {FindSuccess, limit, useModal} from "utils";

const ACTION_TYPE = "GET_USERS";
const ACTION_DELETE = "DELETE_USER";
const ACTION_CHANGE_STATUS = "CHANGE_STATUS_USERS";

export const Users = () => {
    const usersList = useSelector((state) => state.users?.usersList);
    const dispatch = useDispatch();
    const location = useLocation();
    const {openModal, close} = useModal();
    const info = location?.state;
    const successChangeStatus = FindSuccess(ACTION_CHANGE_STATUS);

    const getUsers = (noLoad) => {
        const params = {
            ...info,
        };
        params.skip = info?.skip ? info?.skip : 0;
        params.limit = limit;

        dispatch(usersActions.getUsers(params, noLoad));
    }


    useEffect(() => {
        if (successChangeStatus?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_CHANGE_STATUS))
            getUsers(true)
        }
    }, [successChangeStatus]);

    useEffect(() => {
        getUsers()
    }, [info]);

    const addUser = (item) => {
        openModal(<AddUser info={item} afterSuccess={() => getUsers(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: '850px'
        });
    };

    const handleDelete = (item) => {
        openModal(
            <DeleteModal
                handleDelete={() => {
                    dispatch(usersActions.deleteUser(item?.id));
                }}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.name} ?`}
                afterSuccess={() => {
                    getUsers(true);
                    close();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: '407px'
            },
        );
    };

    const handleClickRow = (item) => {
        openModal(<UserSingle item={item} afterSuccess={() => getUsers(true)}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1276
        });
    };

    return (
        <div className="users-page-wrapper">
            <MainInfo
                buttonText="Add Member"
                headerTable={usersHead()}
                bodyTable={usersBody({
                    handleDelete,
                    handleEit: (item) => addUser(item),
                })}
                clickToAddButton={() => addUser()}
                listTable={usersList?.admins}
                listCountTable={usersList?.count}
                actionType={ACTION_TYPE}
                handleClickRow={handleClickRow}
                emptyState={emptyState(addUser)}
            />
        </div>
    );
};
